import { render, staticRenderFns } from "./text-element.vue?vue&type=template&id=2e43e6ae&scoped=true&"
import script from "./text-element.vue?vue&type=script&lang=js&"
export * from "./text-element.vue?vue&type=script&lang=js&"
import style0 from "./text-element.vue?vue&type=style&index=0&id=2e43e6ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e43e6ae",
  null
  
)

export default component.exports